/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useEffect, useRef } from 'react';
import {
    Tab,
    Tabs,
    makeStyles,
    Button,
} from '@material-ui/core';

import Slider from 'react-slick';
import PlayBookFlowersCard from './PlayBookFlowersCard'
import PlayBookGoogleCard from './PlayBookGoogleCard'
// import PlayBookRecipeList from './PlayBookRecipeList'
import SpotifyList from './SpotifyList'
import EventCard from './EventCard'
// import RootedInLoveSVG from './RootedInLove';
import PlayBookHeader from './PlayBookHeader';
// import NoDataError from './NoDataError';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import NoDataError from './NoDataError';

const useStyles = makeStyles((theme) => ({
    generation: {
        height: '10px',
        minHeight: 'fit-content',
        margin: '50px 0',
        color: '#B3261D',
        fontFamily: 'Roboto Condensed, serif !important',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            textAlign: 'left',
            margin: '20px 0',
        },
        '& .generatedHeader': {
            fontSize: '40px !important',
            textAlign: 'left',
            [theme.breakpoints.down('sm')]: {
                fontSize: '36px !important',
                textAlign: 'left',
                marginBottom: '1rem',
            },
        },
        '& .mbp-account-MuiTabs-indicator': {
            backgroundColor: 'transparent !important'
        },
        // '& #headerAndCopyContainer': {
        //     textAlign: 'center',
        // }
        '& .lastCard':{
            [theme.breakpoints.down('sm')]: {
                width: '115% !important',
            },
            [theme.breakpoints.up('sm')]: {
                width: '100% !important',
            },
            [theme.breakpoints.up('md')]: {
                width: '113% !important',
            },
            
        }
    },
    iconsContainer: {
        display: 'flex',
        justifyContent: 'start',
        gap: '12px',
        width: 'fit-content',
        height: '40px',
        marginBottom: '16px',
    },
    icon: {
        backgroundColor: '#F5E2DC',
        height: '40px',
        width: '40px',
        padding: '9.09px',
        borderRadius: '90.91px',
        gap: '9.09px',
        color: '#B3261D',
        cursor: 'pointer'
    },
    tabsContainer: {
        // display: 'flex',
        // flexDirection: 'row',
        // flexWrap: 'wrap',
        // justifyContent: 'center',
        // alignItems: 'center',
        // textDecoration: 'Uppercase'
    },
    tab: {
        cursor: 'pointer',
        color: '#B3261D !important',
        fontSize: '14px',
        fontWeight: '700',
        lineHeight: '28px',
        textDecoration: 'none',
        borderRadius: '0.375rem !important',
        padding: '8px 18px',
        gap: '10px',
        backgroundColor: '#F5E2DC !important',
        borderColor: 'transparent !important',
        margin: '0.125rem',
        opacity: '1',
        height: '3.75rem',
        width: '5.3rem !important',
        letterSpacing: '1px',
        '&.Mui-selected': {
            backgroundColor: '#B3261D !important',
            color: 'white !important',
        },
        '& span': {
            fontSize: '1rem !important',
            fontFamily: 'Roboto Condensed',
            lineHeight: '1.75rem !important',
            fontWeight: '500'
        },
    },
    hiddenTab: {
        display: 'none',
    },
    cardContainer: {
        backgroundColor: '#FFF',
        display: 'flex !important',
        alignItems: 'center',
        padding: '2rem',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        margin: '20px auto',
        width: '601px',
        height: '646px',
        borderRadius: '6px',
        [theme.breakpoints.down('sm')]: {
            width: '82vw !important',
        },
        [theme.breakpoints.up('sm')]: {
            width: '79vw !important',
        },
        [theme.breakpoints.up('md')]: {
            width: '39vw !important',
        },
        '& p': {
            color: '#B3261D',
            fontSize: '2rem !important',
            fontWeight: '600',
            lineHeight: '3rem',
            fontFamily: 'Playfair Display !important',
            letterSpacing: '0px',
            [theme.breakpoints.down('sm')]: {
                fontSize: '1.6rem !important',
              },
        }
    },
    cardContent: {
        minHeight: '300px',
        // '& p': {
        //     minWidth: '425px !important',
        //     margin: 'auto !important',
        // }
        
    },
    buttonIcon: {
        fontSize: '16px',
        marginLeft: '4px',
        color: '#B3261D'
    },
    rootedInLoveSVGIcon: {
        position: 'absolute',
        zIndex: -1,
        top: '180px',
        right: '30px',
        '& svg': {
            width: '386px',
            height: '386px',
        },
        [theme.breakpoints.down('sm')]: {
            top: '255px',
            right: '0px',
            '& svg': {
                width: '207px',
                height: '207px',
            },
        },
    },
    tabSliderContainer: {
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            width: '95vw',
        },
        [theme.breakpoints.up('sm')]: {
            width: '85vw',
        },
        [theme.breakpoints.up('md')]: {
            width: '50vw',
        }
    },
    sliderContainer: {
        width: '100%',
        maxWidth: '100%',
        overflow: 'hidden',
        zIndex: '2',
        '& .slick-list': {
            [theme.breakpoints.down('sm')]: {
                width: '94vw !important',
            },
            [theme.breakpoints.up('sm')]: {
                width: '84vw !important',
            },
            [theme.breakpoints.up('md')]: {
                width: 'calc(50vw - 100px) !important',
            }
        },
        '& .slick-track': {
            display: 'flex',
        },
        '& .slick-arrow': {
            width: '2rem !important',
            backgroundColor: 'transparent !important',
            color: 'black !important',
            border: 'none !important',
            minWidth: '50px !important',
            marginRight: '0 !important',
            padding: '0 !important', 
            zIndex: '999',
            [theme.breakpoints.down('sm')]: {
                display: 'none !important',
            },
        },
        '& .slick-slide': {
            width: '620px !important',
            padding: '0 20px !important',
            [theme.breakpoints.down('sm')]: {
                width: '93vw !important',
            },
            [theme.breakpoints.up('sm')]: {
                width: '83vw !important',
                marginLeft: '8px',
            },
            [theme.breakpoints.up('md')]: {
                width: 'calc(49vw - 100px) !important',
            }
        },
        '& .slick-disabled': {
            visibility: 'hidden',
            opacity: '0',
        },
    }
}))
  

const PlayBookGeneration = (props) => {
    const { products, google, spotify, events, valentinesName, isMobile } = props;
    const classes = useStyles();
    const [value, setValue] = useState(0);
    const [isSlideTransitioning, setSlideTransitioning] = useState(false);

    // const isEatInAndEatOutBoth = google?.length > 0 && meals?.length > 0
    // getTotalSlides(props);
    // const wholeBody = document.getElementById('main_body');
    // wholeBody.style.backgroundColor = '#B3261D';
    // console.log('[+] wholeBody: ', wholeBody);
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    // useEffect(() => {
    //     if (isEatInAndEatOutBoth) {
    //         const element = document.querySelector('#dinnerTab');
    //         if(value ===2 || value ===3){
    //             element?.classList?.add('Mui-selected');
    //         }
    //         else if(value!==2 || value !==3){
    //             element?.classList?.remove('Mui-selected');
    //         }
    //     }
    // }, [value])

    useEffect(() => {
        sliderRef?.current?.slickGoTo(value);
    }, [value])

    const handleTabChange = (_event, newValue) => {
        if (!isSlideTransitioning) {
            setSlideTransitioning(true);
            setValue(newValue);
            setTimeout(() => {
                setSlideTransitioning(false);
            }, 500);
        }
    };
    const handleMouseDown = () => {
        if (isSlideTransitioning) {
            setSlideTransitioning(false);
        }
    };
    const handleTouchStart = () => {
        if (isSlideTransitioning) {
            setSlideTransitioning(false);
        }
    };
    const handleSlideChange = (currentSlide) => {
        setValue(currentSlide);
    };
    const sliderRef = useRef();

    // const renderEatOut = () => {
    //         return (
    //             <PlayBookGoogleCard cardHeader='EAT OUT' cardSubHeader={google?.[0]?.primaryTypeDisplayName?.text} restaurants={google} actionLabels={['Shuffle']} />
    //         );
    // }
    // const renderEatIn = () => {
    //         const { category } = meals?.[0];
    //         return (
    //             <PlayBookRecipeList cardHeader='EAT IN' cardSubHeader={`${category} cuisine`} items={meals} actionLabels={['Shuffle']} isMobile={isMobile} />
    //         )
    // }

    // const handleChangeIndex = (index) => {
    //     setValue(index)
    // };

    const PrevBtn = (props) => {
        const { className, onClick } = props;
        // we can disable prev arrow on 0th slide but there was jittery effect post moving to next slide, so commented this logic now.
        // const { className, onClick, currentSlide } = props;
        // const isVisible = currentSlide !== 0;
        return (
            <>
                {(
                    <Button className={className} onClick={onClick}>
                        <ArrowBackIosIcon />
                    </Button>
                )}
            </>
        );
    };
    // const NextBtn = (props) => {
    //     const { className, onClick, currentSlide } = props;
    //     let maxLengthCondition = 5;
    //     if (isEatInAndEatOutBoth) {
    //         maxLengthCondition += 1;
    //     }
    //     return (
    //         <>
    //             {currentSlide !== maxLengthCondition && (
    //                 <Button className={className} onClick={onClick}>
    //                     <ArrowForwardIosIcon />
    //                 </Button>
    //             )}
    //         </>
    //     );
    // };
    const NextBtn = (props) => {
        const { className, onClick, currentSlide } = props;
        return (
          <>
            {currentSlide !== 5 && (
              <Button className={className} onClick={onClick}>
                <ArrowForwardIosIcon />
              </Button>
            )}
          </>
        );
      };


    return (
        <>
            {
                /* Need GraphqlSeoHeadTags? */
            }
            <div className={classes.generation}>
                <div>
                    <PlayBookHeader />
                </div>
                {/* <div id='rootedInLoveIconGeneratedPage' className={classes.rootedInLoveSVGIcon}>
                    <RootedInLoveSVG />
                </div> */}
                <div className={classes.tabSliderContainer}>
                    <div className={classes.tabsContainer}>
                        <Tabs
                            value={value}
                            onChange={handleTabChange}
                            variant="fullWidth"
                            aria-label="full width tabs example"
                            onMouseDown={handleMouseDown}
                            onTouchStart={handleTouchStart}
                        >
                            <Tab className={classes.hiddenTab} label="" />
                            
                            <Tab className={classes.tab} label="Dinner" />
                            {/* <Tab id= 'dinnerTab' className={classes.tab} label="Dinner" />
                            {isEatInAndEatOutBoth && <Tab className={classes.hiddenTab} label="" />} */}
                            <Tab className={classes.tab} label="Music" />
                            <Tab className={classes.tab} label="Event" />
                            <Tab className={classes.tab} label="Flowers" />
                            <Tab className={classes.hiddenTab} label="" />
                        </Tabs>
                    </div>
                    <Slider
                        ref={sliderRef}
                        dots={false}
                        infinite={false}
                        speed={500}
                        slidesToShow={1}
                        slidesToScroll={1}
                        swipeToSlide={true}
                        centerMode={false}
                        arrows={!isMobile}
                        nextArrow={<NextBtn />}
                        prevArrow={<PrevBtn />}
                        className={`carousel-container ${classes.sliderContainer}`}
                        beforeChange={(oldIndex, newIndex) => handleSlideChange(newIndex)}
                    >
                        <div className={classes.cardContainer}>
                            <div className={classes.cardContent}>
                                <p>Here you have it! </p>
                                <p>The Official 1-800-Flowers Valentine's Playbook 🌹, where love meets strategy, and romance gets a game plan!</p>
                            </div>
                        </div>
                        { (google && google.length > 0) ? <div>
                            <PlayBookGoogleCard cardHeader='MAKE A RES' cardSubHeader={`${google?.[0]?.primaryTypeDisplayName?.text.split(' ')[0]} Wonders 🪩`} restaurants={google} actionLabels={['Shuffle']} /> </div> : <div><NoDataError /></div>
                        }
                        {/* {google && google.length > 0 && <div>
                            { renderEatOut()}
                        </div>}  */}
                        {/* {meals && meals.length > 0 && <div>
                            { renderEatIn()}
                        </div>} */}
                        {/* {(!meals || meals.length === 0) &&  */}
                        {/* {(!google || google.length === 0) && (
                            <div><NoDataError /></div>
                        )} */}
                        <div>
                            <SpotifyList cardHeader='THE MOOD' cardSubHeader="Valentine’s Love Beats 🎵" items={spotify} actionLabels={['Spotify']} isMobile={isMobile} />
                        </div>
                        <div>
                            <EventCard cardHeader='PLAN A DATE' cardSubHeader={`Make Memories with ${valentinesName} 🌟`} items={events} actionLabels={['Shuffle']} />
                        </div>
                        <div>
                            <PlayBookFlowersCard cardHeader='THE SURPRISE' cardSubHeader={`For ${valentinesName} 🌹`} products={products} actionLabels={['Shuffle', 'Buy Now']} />
                        </div>
                        <div className='lastCard'>
                            <div className={classes.cardContainer}>
                                <div className={classes.cardContent}>
                                    <p>Use this playbook as a personalized roadmap to your Valentine's victory! Flowers speak volumes, but the best gift is a shared experience. Happy Valentine’s Day! ✨🌹‍✨</p>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>
        </>
    )
};

export default PlayBookGeneration;
